import { useMemo } from 'react'
import { useAppSelector } from 'reduxTyped'
import { l, BasicSelectOption } from '@manychat/manyui'

import { getGroupsForAssigneePicker } from 'common/groups/selectors/groupsSelectors'
import { getAgentsForAssigneePicker } from 'common/settings/selectors/botSettingsSelectors'

export const useAssigneeOptions = (value?: number | string | null) => {
  const agentsOptions = useAppSelector(getAgentsForAssigneePicker)
  const groupsOptions = useAppSelector(getGroupsForAssigneePicker)

  const options: BasicSelectOption[] = useMemo(
    () => [
      ...(groupsOptions.length > 0
        ? [
            { label: l.translate('Groups'), value: 'groups', type: 'group' as const },
            ...groupsOptions.map((option) => ({
              label: option.name,
              value: String(option.value),
              type: 'item',
              'data-test-id': `bot-assignee-picker/group`,
            })),
          ]
        : []),
      ...(agentsOptions.length > 0
        ? [
            { label: l.translate('Agents'), value: 'agents', type: 'group' as const },
            ...agentsOptions.map((option) => ({
              label: option.name,
              value: String(option.value),
              'data-test-id': `bot-assignee-picker/agent`,
            })),
          ]
        : []),
    ],
    [agentsOptions, groupsOptions],
  )

  const selectedOptionValue = useMemo<BasicSelectOption | null>(() => {
    if (value == null) return null

    return options.find((option) => option.value === String(value)) ?? null
  }, [value, options])

  return { options, selectedOptionValue }
}
